module.exports = __webpack_public_path__ + "img/00023.dae4d753.webp";